import React, { useState } from "react";
import { Button } from "@mantine/core";

import { AssessmentOpccResults } from "@components/Assessment";

import AddForm from "./AddForm";

import "./index.scss";

export default function CalculationContainers({
  assessment,
  organizationId,
  scoringResultId,
  fetchData,
}) {
  const [isOpen, setOpen] = useState(false);

  function onCreate() {
    fetchData();
    setOpen(false);
  }

  return (
    <div>
      <Button onClick={() => setOpen(!isOpen)} mb="md">
        {isOpen ? "View Calculation Containers" : "Add Calculation Container"}
      </Button>
      {isOpen ? (
        <AddForm
          scoringResultId={scoringResultId}
          organizationId={organizationId}
          fetchData={onCreate}
        />
      ) : (
        assessment && (
          <AssessmentOpccResults
            assessment={assessment}
            organizationId={organizationId}
          />
        )
      )}
    </div>
  );
}
